import { graphql, Link, useStaticQuery } from "gatsby";
import React from "react";

export default function CaseStudiesListFooter() {
  const { caseStudy } = useStaticQuery(graphql`
    query {
      caseStudy: allSanityCaseStudies(sort: { title: ASC }) {
        nodes {
          title
          id
          slug {
            current
          }
        }
      }
    }
  `);

  const thecasestudies = caseStudy.nodes;

  return (
    <>
      <span className="block pb-2 text-sm font-normal">Case Studies</span>
      <div>
        {thecasestudies.map((caseStudy, i) => (
          <div key={i}>
            <Link to={`/case-studies/${caseStudy.slug.current}`}>
              <div className="block font-light">
                <span className="block py-1.5 text-xs text-gray-500 hover:text-gray-800">
                  {caseStudy.title}
                </span>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </>
  );
}
